import React, { useState, useEffect } from "react";
import api from "../api/client";
import { GradientText } from "../theme/scala";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Alert,
  CircularProgress,
  Chip,
  Stack,
  Fade,
} from "@mui/material";
import {
  SettingsRounded as SettingsIcon,
  NotificationsActiveRounded as NotificationsIcon,
  SecurityRounded as SecurityIcon,
  InfoRounded as InfoIcon,
  CheckCircleRounded as SuccessIcon,
} from "@mui/icons-material";

export default function Settings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  // MANTIĞIN AYNI KALDI
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get("/settings");
        setSettings(res.data.data);
      } catch (err) {
        console.error("Ayarlar çekilemedi", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <CircularProgress
          thickness={2}
          size={50}
          sx={{ color: "primary.main" }}
        />
      </Box>
    );

  return (
    <Fade in={true} timeout={800}>
      <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
        {/* BAŞLIK ALANI */}
        <Box sx={{ mb: 6, display: "flex", alignItems: "center", gap: 2.5 }}>
          <Box
            sx={{
              p: 2,
              borderRadius: 3,
              background:
                "linear-gradient(135deg, rgba(29,111,242,0.1) 0%, rgba(45,167,255,0.1) 100%)",
              border: "1px solid rgba(29,111,242,0.2)",
            }}
          >
            <SettingsIcon sx={{ fontSize: 32, color: "primary.light" }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ fontSize: "2.1rem" }}>
              Sistem <GradientText>parametreleri</GradientText>
            </Typography>
            <Typography sx={{ color: "text.secondary" }} variant="body2">
              Visione çekirdek ayarları ve güvenlik eşikleri.
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={4}>
          {/* ALARM EŞİKLERİ KARTI */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                bgcolor: "background.paper",
                borderRadius: 4,
                height: "100%",
                border: "1px solid rgba(234,240,248,0.05)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Stack sx={{ alignItems: "center", mb: 3 }} direction="row" spacing={1.5}>
                  <NotificationsIcon sx={{ color: "warning.main" }} />
                  <Typography sx={{ fontWeight: "bold" }} variant="h6">
                    Kritik Alarm Eşikleri
                  </Typography>
                </Stack>

                <Alert
                  severity="info"
                  icon={<InfoIcon fontSize="small" />}
                  sx={{
                    mb: 4,
                    bgcolor: "rgba(59, 130, 246, 0.05)",
                    color: "info.light",
                    border: "1px solid rgba(59, 130, 246, 0.2)",
                    borderRadius: 2,
                  }}
                >
                  Bu değerler aşıldığında sistem yöneticisine otomatik uyarı
                  gönderilir.
                </Alert>

                <Stack spacing={1}>
                  <SettingRow
                    label="Kritik RAM Kullanımı"
                    value={`%${settings?.thresholds?.ram}`}
                  />
                  <SettingRow
                    label="Kritik CPU Kullanımı"
                    value={`%${settings?.thresholds?.cpu}`}
                  />
                  <SettingRow
                    label="DDoS Koruma Limiti"
                    value={`${settings?.thresholds?.ddos_limit} req/ip`}
                  />
                  <SettingRow
                    label="SSL Sertifika Uyarısı"
                    value={`Son ${settings?.thresholds?.ssl_days} gün`}
                    isLast
                  />
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          {/* GÜVENLİK VE SİSTEM KARTI */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                bgcolor: "background.paper",
                borderRadius: 4,
                height: "100%",
                border: "1px solid rgba(234,240,248,0.05)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Stack sx={{ alignItems: "center", mb: 3 }} direction="row" spacing={1.5}>
                  <SecurityIcon sx={{ color: "success.main" }} />
                  <Typography sx={{ fontWeight: "bold" }} variant="h6">
                    Sistem Durumu
                  </Typography>
                </Stack>

                <Stack spacing={1}>
                  <SettingRow
                    label="Yazılım Versiyonu"
                    value={
                      <Chip
                        label={`v${settings?.system?.version}`}
                        size="small"
                        color="primary"
                        sx={{ fontWeight: "bold", borderRadius: 1.5 }}
                      />
                    }
                  />
                  <SettingRow
                    label="Yönetici E-Posta"
                    value={settings?.system?.adminEmail}
                  />
                  <SettingRow
                    label="Veritabanı Motoru"
                    value={
                      <Stack sx={{ alignItems: "center" }} direction="row" spacing={1}>
                        <SuccessIcon
                          sx={{ color: "success.main", fontSize: 18 }}
                        />
                        <Typography sx={{ color: "success.main", fontWeight: "bold" }}
                          variant="body2"
                        >
                          Aktif
                        </Typography>
                      </Stack>
                    }
                  />
                  <SettingRow
                    label="Oturum (JWT) Ömrü"
                    value="12 Saat"
                    isLast
                  />
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* ALT BİLGİ */}
        <Box sx={{ mt: 6, textAlign: "center", opacity: 0.5 }}>
          <Typography sx={{ color: "text.secondary" }} variant="caption">
            Visione Core Engine • {new Date().getFullYear()} • ScalaVisione
            Digital Solutions
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
}

// AYAR SATIRI YARDIMCI BİLEŞENİ - TASARIM GÜNCELLENDİ
function SettingRow({ label, value, isLast }) {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2.5,
          px: 1,
          transition: "all 0.2s",
          "&:hover": { bgcolor: "rgba(234,240,248,0.02)", borderRadius: 2 },
        }}
      >
        <Typography sx={{ color: "text.secondary", fontWeight: 500 }} variant="body1">
          {label}
        </Typography>
        <Box
          sx={{ textAlign: "right", fontWeight: "bold", color: "text.primary" }}
        >
          {value}
        </Box>
      </Box>
      {!isLast && <Divider sx={{ borderColor: "rgba(234,240,248,0.05)" }} />}
    </Box>
  );
}
